import {get as _get} from 'lodash';
import {withRouter} from 'react-router';

import {setBlackoutZones, setDeviceFields} from '@utils/event/blackoutZones';
import {editValidation, onCloseModal, setMutationSuccess} from '@modules/eventBooking/forms/helpers/helpers';
import {
    getEventBookingDataFromAllSteps,
    showDefaultDeleteModal,
} from '@modules/events/utils/EventEventBooking/eventBookingDataFromAllSteps';
import {EventBookingBlackoutZonesForm} from '@modules/eventBooking/forms/EventBookingBlackoutZonesForm';

export class EventBookingBlackoutZonesEditForm extends EventBookingBlackoutZonesForm {
    componentDidMount() {
        this.setUpdateSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });
        this.setDeleteSuccessCallback(() => {
            if (this.props.formParams.optionsVariables.event) {
                setMutationSuccess(this.props);
            }

            onCloseModal(
                this.props.formParams.optionsVariables.event,
                this.props.formParams.optionsVariables.client,
                this.props.Modal.setModal,
                this.props
            );
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        const {
                GraphQLEntityData,
                GraphQLOptionsData,
            } = this.props,
            isLoading = GraphQLEntityData?.loading || GraphQLOptionsData.loading;

        if (this.state.switchesStatus !== this.props.switches) {
            setDeviceFields(this.setField, this.setState, this.props.switches);
        }

        if ((!isLoading && !this.state.dataLoaded)) {
            const eventBookingGeoRestrictions = _get(GraphQLEntityData, 'eventEventBooking.event_booking_geo_restrictions', []),
                previousStepData = _get(this.props, 'previousStepData', {}),
                blackoutZonesOptions = _get(GraphQLOptionsData, 'blackoutZones', []);

            setBlackoutZones(this.setField, previousStepData, blackoutZonesOptions, eventBookingGeoRestrictions);

            this.setState(() => ({dataLoaded: true}));
        }
    }

    prepareDataForSubmit = () => {
        return getEventBookingDataFromAllSteps(this.props.stepsMethods, this.props.formParams.id);
    };

    onFormSubmit = (data) => {
        if (editValidation(this.props.stepsMethods)) {
            this.setState(() => ({
                defaultForm_loading: true,
            }));
            super.onFormSubmit(data);
        }
    };

    deleteButtonClick = (e) => {
        showDefaultDeleteModal(this, e);
    };
}

export default withRouter(EventBookingBlackoutZonesEditForm);
